import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { IDriver } from 'apps/fleet-planner/types'
import { ISuccessAction } from '../types/drivers'

export const FETCH_DRIVERS_ACTION_TYPES = generateApiActionTypes('FETCH_DRIVERS')
const { FETCH_DRIVERS_SUCCESS } = FETCH_DRIVERS_ACTION_TYPES

export const fetchDriversSuccess = (drivers: IDriver[]): ISuccessAction => ({
  type: FETCH_DRIVERS_SUCCESS,
  payload: {
    drivers,
  },
})

export const fetchDrivers = () => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: FP_ENDPOINTS.drivers,
      method: 'GET',
      params: {
        sortField: 'name',
        sortOrder: 'asc',
      },
    },
    actionTypes: Object.keys(FETCH_DRIVERS_ACTION_TYPES),
  },
})
